// extracted by mini-css-extract-plugin
module.exports = {"category":"enllac_category__mlGbg","boto":"enllac_boto__fuPmI"};